// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    CourseManagementModel,
    updateRegisteredUser as updateRegisteredUserApi,
} from "@stoneage/App/Services/CourseManagement/CourseManagementService";

export interface UpdateRegisteredUserParameter {
    firstName: string;
    lastName: string;
    company: string;
    courseId: string;
    registrationId: string;
}

type HandlerType = ApiHandler<
    UpdateRegisteredUserParameter & HasOnSuccess<ServiceResult<CourseManagementModel>> & HasOnError<string>,
    ServiceResult<CourseManagementModel>
>;
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const UpdateRegisteredUser: HandlerType = async props => {
    const { onSuccess, onError, ...apiParameter } = props.apiParameter;
    props.apiResult = await updateRegisteredUserApi(apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, UpdateRegisteredUser, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];
const updateRegisteredUser = createHandlerChainRunner(chain, "UpdateRegisteredUser");

export default updateRegisteredUser;
